import React, { Component } from 'react';

class TimeRangeFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startTime: '',
      endTime: '',
    };
  }

  timeFormat = time => {
    if (!time) return '';
    let timeFormatted = time.replace(/\D/g, '');
    let hour = timeFormatted.substring(0, 2);
    let minute = timeFormatted.substring(2, 4);
    let second = timeFormatted.substring(4, 6);

    hour = hour > 23 ? '23' : hour;
    minute = minute > 59 ? '59' : minute;
    second = second > 59 ? '59' : second;

    return `${hour}${minute ? ':' + minute : ''}${second ? ':' + second : ''}`;
  };

  handleTimeInput = (field, value) => {
    const formattedTime = this.timeFormat(value);
    this.setState({ [field]: formattedTime }, () => {
      this.applyFilter();
    });
  };

  applyFilter = () => {
    const { startTime, endTime } = this.state;

    if (startTime || endTime) {
      // Criar um objeto de filtro que será interpretado pelo backend
      const filterValue = {
        start: startTime,
        end: endTime,
      };

      // Passar o filtro para o componente pai
      if (this.props.onChange) {
        this.props.onChange(JSON.stringify(filterValue));
      }
    } else {
      // Se ambos estão vazios, limpar o filtro
      if (this.props.onChange) {
        this.props.onChange('');
      }
    }
  };

  render() {
    const { startTime, endTime } = this.state;

    return (
      <div className="time-range-inputs-container">
        <input
          type="text"
          className="time-range-input"
          placeholder="Hora Início"
          value={startTime}
          maxLength={8}
          onChange={e => this.handleTimeInput('startTime', e.target.value)}
        />
        <input
          type="text"
          className="time-range-input"
          placeholder="Hora Fim"
          value={endTime}
          maxLength={8}
          onChange={e => this.handleTimeInput('endTime', e.target.value)}
        />
      </div>
    );
  }
}

export default TimeRangeFilter;
